var map = {
	"./icon_close_no_bag.svg": 62258,
	"./icon_excel.svg": 54204,
	"./icon_other.svg": 85851,
	"./icon_pdf.svg": 13395,
	"./icon_ppt.svg": 57365,
	"./icon_word.svg": 1659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29533;